module.exports = __webpack_public_path__ + "img/H1.c5ee662d.png";